<template>
    <div class="ship-vetting-container">
        <transition name="fade-transform" mode="out-in">
            <div v-if="pageStatus == 0">
                <HoldingCertList class=" barging-container"></HoldingCertList>
            </div>
            <div v-if="pageStatus == 1 || pageStatus == 2">
                <HoldingCertDetail class="top2"></HoldingCertDetail>
            </div>
        </transition>
    </div>
</template>

<script>
import tabs from "@/components/tabs.vue";
import { mapState } from "vuex";
import HoldingCertDetail from './component/detail.vue'
import HoldingCertList from './component/list.vue'
export default {
    components: { tabs, HoldingCertList, HoldingCertDetail },
    watch: {
        "$route.query": {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (this.$route.query.pageStatus) {
                    this.pageStatus = this.$route.query.pageStatus
                } else {
                    this.pageStatus = 0
                }
            },
        },
        locale() {
            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },
        pageStatus() {
        }
    },
    data() {
        return {
            pageStatus: 0,
            disclaimers: [],
            currentDisclaimer: null,
            upIndex: 0,
        };
    },
    computed: {
        ...mapState(["locale", "userInfo", "screenType"]),
        isMobileScreen() {
            return this.screenType?.isMobileScreen ?? false;
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.$refs.orderListRef) {
            this.$refs.orderListRef.handleStopRefresh()
        }
        next()
    },
    created() {
    },
    methods: {

    },
};
</script>

<style scoped lang="scss">
.top {
    // height: 100vh;
    // position: relative;
    // width: 100%;
    height: calc(100vh - 90px);
    // overflow: hidden;
    // box-sizing: border-box;
}
</style>